import { TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { indigo } from '@material-ui/core/colors';
import FormGroup from '@material-ui/core/FormGroup';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actionTypes from '../../../store/NewPatient/actionType';
import { withLang } from '../../../util/lang';
import { getWebAbsPath } from '../../../util/path';
import styles from './NewPatientRetrack.module.css';
import { styled } from '@material-ui/core/styles';

const RedTextField = styled(TextField)({
    '& label': {
        color: 'rgba(147,147,147,255) !important',
    },
    '& label.Mui-focused': {
        color: 'rgba(147,147,147,255) !important',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'rgba(147,147,147,255) !important',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'red !important',
        },
        '&:hover fieldset': {
            borderColor: 'red !important',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'red !important',
        },
    },
});

const IndigoCheckbox = withStyles({
    root: {
        color: indigo[500],
        '&$checked': {
            color: indigo[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const gridStyles = (rowStart, columnStart) => ({
    gridColumnStart: columnStart,
    gridColumnEnd: columnStart + 1,
    gridRowStart: rowStart,
    gridRowEnd: rowStart + 1,
});

class NewPatientRetrack extends Component {
    constructor(props) {
        super(props);

        /*
      this.state = {
        dialogOpen: false,
        errorFrom: ''
      }
      this.changeState = this.changeState.bind(this);
      this.getNotes = this.getNotes.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleDialog = this.handleDialog.bind(this);
      this.getWarning = this.getWarning.bind(this);
  
  
      this.specialInstructionsRef = React.createRef();
      */
    }
    /*
    getNotes = (title) => {
      return this.get(`prescriptionNotes.${title}`)
    }
    

    getWarning = (title) => {
      return this.get(`warning.${title}`)
    }
    */

    handleClick = (e, func) => {
        const { left, top } = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;

        for (let [_, objValue] of Object.entries(this.teeth)) {
            if (x > objValue.maxX || x < objValue.minX || y > objValue.maxY || y < objValue.minY) continue;
            for (let i = 0; i < objValue.values.length; i++) {
                const { value, boundX } = objValue.values[i];
                if (boundX < x) continue;
                func(value);
                break;
            }
            break;
        }
    };
    componentDidUpdate(prevProps, prevState) {}

    changeState = (field, value) => {
        this.setState((state) => ({
            ...state,
            [field]: value,
        }));
    };

    handleClickScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    handleDialog = () => {
        this.changeState('dialogOpen', !this.state.dialogOpen);
    };

    validation = (value) => {};

    teeth = {
        topRight: {
            maxX: 590,
            maxY: 80,
            minX: 50,
            minY: 20,
            values: [
                {
                    value: 0,
                    positionX: 90,
                    positionY: 50,
                    boundX: 130,
                },
                {
                    value: 1,
                    positionX: 170,
                    positionY: 50,
                    boundX: 210,
                },
                {
                    value: 2,
                    positionX: 255,
                    positionY: 50,
                    boundX: 300,
                },
                {
                    value: 3,
                    positionX: 330,
                    positionY: 50,
                    boundX: 365,
                },
                {
                    value: 4,
                    positionX: 400,
                    positionY: 50,
                    boundX: 430,
                },
                {
                    value: 5,
                    positionX: 460,
                    positionY: 50,
                    boundX: 482,
                },
                {
                    value: 6,
                    positionX: 510,
                    positionY: 50,
                    boundX: 540,
                },
                {
                    value: 7,
                    positionX: 565,
                    positionY: 50,
                    boundX: 590,
                },
            ],
        },
        topLeft: {
            maxX: 1130,
            maxY: 80,
            minX: 590,
            minY: 20,
            values: [
                {
                    value: 8,
                    positionX: 620,
                    positionY: 50,
                    boundX: 650,
                },
                {
                    value: 9,
                    positionX: 670,
                    positionY: 50,
                    boundX: 700,
                },
                {
                    value: 10,
                    positionX: 725,
                    positionY: 50,
                    boundX: 750,
                },
                {
                    value: 11,
                    positionX: 780,
                    positionY: 50,
                    boundX: 820,
                },
                {
                    value: 12,
                    positionX: 850,
                    positionY: 50,
                    boundX: 885,
                },
                {
                    value: 13,
                    positionX: 928,
                    positionY: 50,
                    boundX: 970,
                },
                {
                    value: 14,
                    positionX: 1010,
                    positionY: 50,
                    boundX: 1050,
                },
                {
                    value: 15,
                    positionX: 1092,
                    positionY: 50,
                    boundX: 1130,
                },
            ],
        },
        bottomRight: {
            maxX: 590,
            maxY: 250,
            minX: 50,
            minY: 180,
            values: [
                {
                    value: 16,
                    positionX: 90,
                    positionY: 220,
                    boundX: 130,
                },
                {
                    value: 17,
                    positionX: 170,
                    positionY: 220,
                    boundX: 210,
                },
                {
                    value: 18,
                    positionX: 255,
                    positionY: 220,
                    boundX: 300,
                },
                {
                    value: 19,
                    positionX: 330,
                    positionY: 220,
                    boundX: 365,
                },
                {
                    value: 20,
                    positionX: 400,
                    positionY: 220,
                    boundX: 430,
                },
                {
                    value: 21,
                    positionX: 460,
                    positionY: 220,
                    boundX: 482,
                },
                {
                    value: 22,
                    positionX: 510,
                    positionY: 220,
                    boundX: 540,
                },
                {
                    value: 23,
                    positionX: 565,
                    positionY: 220,
                    boundX: 590,
                },
            ],
        },
        bottomLeft: {
            maxX: 1130,
            maxY: 250,
            minX: 590,
            minY: 180,
            values: [
                {
                    value: 24,
                    positionX: 620,
                    positionY: 220,
                    boundX: 650,
                },
                {
                    value: 25,
                    positionX: 670,
                    positionY: 220,
                    boundX: 700,
                },
                {
                    value: 26,
                    positionX: 725,
                    positionY: 220,
                    boundX: 750,
                },
                {
                    value: 27,
                    positionX: 780,
                    positionY: 220,
                    boundX: 820,
                },
                {
                    value: 28,
                    positionX: 850,
                    positionY: 220,
                    boundX: 885,
                },
                {
                    value: 29,
                    positionX: 928,
                    positionY: 220,
                    boundX: 970,
                },
                {
                    value: 30,
                    positionX: 1010,
                    positionY: 220,
                    boundX: 1050,
                },
                {
                    value: 31,
                    positionX: 1092,
                    positionY: 220,
                    boundX: 1130,
                },
            ],
        },
    };

    render() {
        const { classes, teethArray } = this.props;
        const items = [];

        return (
            <FormGroup>
                <ol className={styles.list}>
                    <div className={styles.toothImages}>
                        <div
                            style={{
                                width: 1175,
                                height: 300,
                                marginTop: '10px',
                                position: 'relative',
                                backgroundRepeat: 'no-repeat',
                                backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/teeth_number_CS6.ai.png')}")`,
                            }}
                            onClick={(e) => {
                                // if (this.props.readOnly) return
                                // if (!this.validation("excludedDentition")) return
                                if (teethArray === undefined) {
                                    this.handleClick(e, this.props.handleDataAttachment);
                                }
                            }}
                        >
                            {(teethArray ? teethArray : this.props.attachment).map((toothValue) => {
                                for (let [_, objValue] of Object.entries(this.teeth)) {
                                    for (let { value, positionX, positionY } of objValue.values) {
                                        if (value === toothValue) {
                                            return (
                                                <img
                                                    src={getWebAbsPath('/img/prescriptionNotes/checkFail.png')}
                                                    alt="checked"
                                                    style={{
                                                        position: 'absolute',
                                                        top: positionY - 10,
                                                        left: positionX - 12,
                                                        userSelect: 'none',
                                                    }}
                                                />
                                            );
                                        }
                                    }
                                }
                            })}
                        </div>
                    </div>
                </ol>
            </FormGroup>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        NewPatientData: store.newPatientReducer,
        files: store.newPatientReducer.files,
        attachment: store.newPatientReducer.attachment,
        //prescriptionScroll: store.newPatientReducer.prescriptionScroll,
        lang: store.lang,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        // handleDataArchToTreat: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_ARCH_TO_TREAT, value: value }),
        handleDataAttachment: (value) => dispatch({ type: actionTypes.NEW_PATIENT_RETRACK_ATTACHMENT, value: value }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLang(NewPatientRetrack, '')));
